/**
 * @module types/settings/description
 * @description 表格字段描述配置项领域模型（存储字段名 `description`）
 *
 * key 格式: `${table_code}_${column_name}_${column_role}`（0=指标，1=维度）
 */

export interface IDescriptionItem {
  column_name: string;
  table_id: string;
  table_code: string;
  desc: string;
  column_role: number;
}

export type IDescriptionSetting = Record<string, IDescriptionItem>;

/** 弹层/列表用的列元数据（非存储 payload 本身） */
export interface IDescriptionColumnItem {
  id?: string;
  column_name: string;
  table_id: string;
  table_code?: string;
  column_display: string;
}

/**
 * 空描述表的模块级默认引用
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.description 为同一引用语义
 */
export const DESCRIPTION_DEFAULT: IDescriptionSetting = Object.freeze(
  {},
) as IDescriptionSetting;
